import { render } from "./OnboardingView.vue?vue&type=template&id=5561a3ed&scoped=true"
import script from "./OnboardingView.vue?vue&type=script&lang=js"
export * from "./OnboardingView.vue?vue&type=script&lang=js"

import "./OnboardingView.vue?vue&type=style&index=0&id=5561a3ed&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5561a3ed"]])

export default __exports__